import { Box, Stack, Typography } from "@mui/material";

import PnLCard from "../components/PnLCard";
import DeployedAlgos from "../components/DeployedAlgos";
import PaperTrade from "../components/PaperTrade";
import BacktestLog from "../components/BacktestLog";
import { greeting, marketOpen } from "../api";
import type { DashboardPayload } from "../api";
import { PROFILE } from "../profile";

export default function Dashboard({ data }: { data: DashboardPayload }) {
  const open = marketOpen();

  return (
    <Stack gap={2.5}>
      <Stack
        direction="row"
        alignItems="center"
        flexWrap="wrap"
        gap={1.5}
        sx={{ mt: 0.5 }}
      >
        <Typography variant="h1" sx={{ display: "flex", gap: 1.2 }}>
          <span
            style={{ filter: "drop-shadow(0 4px 8px rgba(0,0,0,.5))" }}
            aria-hidden
          >
            👋
          </span>
          <span style={{ color: "var(--muted)", fontWeight: 700 }}>
            {greeting()},
          </span>
          <span>{PROFILE.name}</span>
        </Typography>

        <Stack
          direction="row"
          alignItems="center"
          gap={0.9}
          sx={{
            ml: "auto",
            px: 1.8,
            py: 0.8,
            borderRadius: "22px",
            background: open
              ? "linear-gradient(145deg,#0f7a45,#064d29)"
              : "linear-gradient(145deg,#7a1520,#4d0d14)",
            boxShadow: `inset 0 1px 0 rgba(255,255,255,.25), 0 4px 14px ${
              open ? "rgba(0,230,118,.28)" : "rgba(244,67,54,.26)"
            }`,
          }}
        >
          <span className={open ? "dot-live" : "dot-off"} />
          <Typography sx={{ fontSize: ".78rem", fontWeight: 700, color: "#fff" }}>
            Market <b>{open ? "Open" : "Closed"}</b>
          </Typography>
        </Stack>
      </Stack>

      <Box
        sx={{
          display: "grid",
          gap: 2,
          gridTemplateColumns: { xs: "1fr", lg: "minmax(330px,.85fr) 1.6fr" },
          alignItems: "start",
        }}
      >
        <PnLCard stats={data.stats} open={data.today} clock={data.clock} />
        <DeployedAlgos open={data.today} closed={data.closed} />
      </Box>

      <PaperTrade />
      <BacktestLog />
    </Stack>
  );
}
